
export const SET_BOOKINGMODAL = "SET_BOOKINGMODAL"
export const JOURNEY_STEP = "JOURNEY_STEP"

const initialState = {
    "showBookingModal": false,
    "journey": []
}

export default function global(state = initialState, action){
    switch(action.type){
        case SET_BOOKINGMODAL:
            return {
                ...state,
                showBookingModal: action.value
            }
        case JOURNEY_STEP:
            return {
                ...state,
                journey: state.journey.concat(action.value)
            }
        default:
            return state
    }
}